export interface TimeGridRulerProps {
  startHour?: number;
  endHour?: number;
  hourHeight?: number;
}

export function TimeGridRuler({
  startHour = 7,
  endHour = 22,
  hourHeight = 72,
}: TimeGridRulerProps) {
  const hours = Array.from({ length: endHour - startHour + 1 }, (_, i) => startHour + i);

  return (
    <div
      className="relative select-none border-r border-border/60 bg-muted/10 text-muted-foreground w-14 sm:w-16 flex-shrink-0"
      style={{ height: (endHour - startHour) * hourHeight }}
    >
      {hours.map((hour, idx) => {
        const isLast = idx === hours.length - 1;
        const topPosition = idx * hourHeight;
        const formattedHour = `${String(hour).padStart(2, '0')}:00`;
        const halfHourFormatted = `${String(hour).padStart(2, '0')}:30`;

        return (
          <div key={hour}>
            {/* Rótulo da hora cheia */}
            <div
              className="absolute right-2 -translate-y-1/2 text-[11px] sm:text-xs font-medium text-muted-foreground/90 tracking-tight"
              style={{ top: topPosition }}
            >
              {formattedHour}
            </div>

            {/* Marcador intermediário de 30min (não desenha após a última hora) */}
            {!isLast && (
              <div
                className="absolute right-2 -translate-y-1/2 text-[9px] font-normal text-muted-foreground/50 tracking-tighter"
                style={{ top: topPosition + hourHeight / 2 }}
              >
                {halfHourFormatted}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
